import React, { useState } from "react";
import Perso from "../../assets/icons/Perso.svg";
import { Button, Col, Row, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import Share from "./Share";
import ModalComponent from "../Modal/ModalComponent";
import ShareProject from "../../components/share-cases/ShareCases";
import share from "../../assets/icons/share.svg";
import GreyButton from "../Buttons/GreyButton";
import { useNavigate } from "react-router-dom";
import { getKey, toFormatAmount } from "../../components/utils/utils";
import ProgressCard from "../progress/ProgressCard";
import completed from "../../assets/images/completed.svg";
import completedGeneralDonation from "../../assets/images/generalDone.png";
interface ComposedCardProps extends React.HTMLAttributes<HTMLDivElement> {
  type: "المشاريع" | "تفريج كرب" | "التبرع العام";
  project: any;
  cardClass?: "card-1" | "card-2" | "card-3";
  isCompleted?: boolean;
  donation_type_ids: any[];
}

const ComposedCard = ({
  type,
  project,
  cardClass,
  isCompleted,
  donation_type_ids,
  ...props
}: ComposedCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Modal visibility state
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [, setSelectedUrl] = useState<string | undefined>("");
  // Function to show modal
  const showModal = (url: string | undefined) => {
    setSelectedUrl(url);
    setIsModalVisible(true);
  };

  // Function to hide modal
  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedUrl("");
  };
  //store amount share state
  const [donationAmount, setDonationAmount] = useState(0);
  //store counter state
  const [counter, setCounter] = useState(1);
  //store selected share state
  const [selectedShare, setSelectedShare] = useState<any>(null);
  //state active donation
  const [selectedDonation, setSelectedDonation] = useState<any>(null);
  // Path generated based on type: projects use their id, others their access_token
  const generatedUrl =
    type === "المشاريع"
      ? `${window.location.origin}/project/${project?.id}`
      : type === "التبرع العام"
      ? `${window.location.origin}/general-donation/${project?.access_token}`
      : `${window.location.origin}/korba/${project?.access_token}/${getKey(
          project.model
        )}`;

  return (
    <div
      {...props}
      className={`takaful--composed-card ${props.className ?? ""} ${
        isCompleted && "takaful--completed-korba"
      }`}
    >
      <div className="takaful--content-card-composed">
        {project.request_type_id && (
          <div className={`takaful--composed-caption ${cardClass ?? ""}`}>
            <p>{project.request_type_id}</p>
          </div>
        )}
        <figure className="img-container">
          <img
            src={
              type === "المشاريع"
                ? project?.title_image_ids && project?.title_image_ids[0]
                  ? project?.title_image_ids[0]
                  : null
                : type === "تفريج كرب"
                ? project?.title_image_ids && project?.title_image_ids[0]
                  ? project?.title_image_ids[0]
                  : null
                : project?.image
            }
            alt=""
            className="main-image"
          />
        </figure>
        <p className="takaful--composed-description">
          {type === "المشاريع"
            ? project?.project_name
            : type === "التبرع العام"
            ? project?.name
            : project?.summary}
        </p>
        {type === "المشاريع" ? (
          <div className="takaful--composed-box1">
            <div className="takaful--part">
              <img src={Perso} alt="" />
              <span>{project.target_number} أفراد</span>
            </div>
          </div>
        ) : null}

        {(type !== "المشاريع" || project?.show_progress_details) && (
          <>
            <ProgressCard
              percent={Math.floor(project?.progress)}
              percentPosition={{
                align: "end",
                type: "inner",
              }}
              size={["100%", 15]}
            />
            <div className="takaful--composed-box2">
              <div className="takaful--part">
                <span>
                  {type === "المشاريع" ? t("composedCard.span1") : "المبلغ "}
                </span>
                <label>
                  {type === "المشاريع"
                    ? toFormatAmount(
                        project.target_amount - project.residual_amount
                      )
                    : toFormatAmount(project.amount)}
                </label>
              </div>
              <div className="takaful--part">
                <span style={{ color: "#1caca5" }}>
                  {t("composedCard.span2")}{" "}
                </span>
                <label>
                  {type === "المشاريع"
                    ? toFormatAmount(project.residual_amount)
                    : toFormatAmount(project.remaining_amount)}
                </label>
              </div>
            </div>
          </>
        )}
      </div>
      <Share
        project={project}
        remainingAmount={
          type === "المشاريع"
            ? project.residual_amount
            : project.remaining_amount
        }
        container="card"
        type={type}
        setDonationAmount={setDonationAmount}
        setCounter={setCounter}
        setSelectedShare={setSelectedShare}
        setSelectedDonation={setSelectedDonation}
        share_ids={project?.share_ids ?? []}
        donation_type_ids={donation_type_ids ?? []}
        isCompleted={isCompleted}
      />
      <Row style={{ width: "100%" }} justify={"space-between"}>
        <Col
          xxl={18}
          xl={18}
          lg={18}
          md={18}
          sm={18}
          xs={18}
          style={{ paddingLeft: "4px" }}
        >
          <GreyButton
            className="takaful--primary-button takaful--grey-color"
            title={
              type === "المشاريع"
                ? "تفاصيل المشروع"
                : type === "التبرع العام"
                ? "تفاصيل التبرع العام"
                : "تفاصيل الحالة"
            }
            style={{ width: "100%" }}
            disabled={isCompleted}
            onClick={() =>
              navigate(
                `${
                  type === "المشاريع"
                    ? `/project/${project.id}`
                    : type === "التبرع العام"
                    ? `/general-donation/${project.access_token}`
                    : `/korba/${project.access_token}/${getKey(project.model)}`
                }`,
                {
                  state: {
                    donationAmount,
                    counter,
                    selectedShare,
                    selectedDonation,
                    type,
                  },
                }
              )
            }
          />
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
          {isCompleted ? (
            <Button
              className="takaful--share-btn"
              onClick={() => showModal(project.url)}
              style={{ width: "100%" }}
              disabled={isCompleted}
            >
              <img src={share} style={{ width: "3em" }} alt="" />
            </Button>
          ) : (
            <Tooltip
              overlayClassName="takaful--share-tooltip"
              placement="bottom"
              title={
                type === "المشاريع"
                  ? "شارك المشروع عبر التواصل الإجتماعي"
                  : type === "التبرع العام"
                  ? "شارك التبرع العام عبر التواصل الإجتماعي"
                  : "شارك الحالة عبر التواصل الإجتماعي"
              }
            >
              <Button
                className="takaful--share-btn"
                onClick={() => showModal(project.url)}
                style={{ width: "100%" }}
                disabled={isCompleted}
              >
                <img src={share} style={{ width: "3em" }} alt="" />
              </Button>
            </Tooltip>
          )}
        </Col>
      </Row>

      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={handleCloseModal}
        closeOnOutsideClick={true}
        width={400}
        modalStyle={{ top: "20%", minHeight: "20vh", height: "20vh" }}
        showCloseIcon={true}
      >
        <ShareProject
          url={generatedUrl}
          type={type}
          title={
            type === "المشاريع"
              ? project?.project_name
              : type === "التبرع العام"
              ? project?.name
              : project?.summary
          }
        />
      </ModalComponent>
      {isCompleted && (
        <img
          src={type === "التبرع العام" ? completedGeneralDonation : completed}
          className="takaful--completed-image"
          alt=""
        />
      )}
    </div>
  );
};

export default ComposedCard;
